var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgApple(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "13px",
    height: "17px",
    viewBox: "0 0 13 17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 10.789062 8.921875 C 10.78125 7.703125 11.34375 6.785156 12.480469 6.105469 C 11.84375 5.210938 10.882812 4.722656 9.613281 4.625 C 8.414062 4.53125 7.097656 5.3125 6.617188 5.3125 C 6.109375 5.3125 4.945312 4.660156 4.03125 4.660156 C 2.144531 4.6875 0.136719 6.136719 0.136719 9.082031 C 0.136719 9.949219 0.296875 10.851562 0.621094 11.777344 C 1.054688 12.996094 2.621094 15.984375 4.253906 15.933594 C 5.105469 15.914062 5.707031 15.339844 6.816406 15.339844 C 7.894531 15.339844 8.453125 15.933594 9.40625 15.933594 C 11.050781 15.910156 12.464844 13.195312 12.878906 11.972656 C 10.671875 10.953125 10.789062 8.984375 10.789062 8.921875 Z M 8.875 3.46875 C 9.796875 2.394531 9.710938 1.414062 9.6875 1.0625 C 8.871094 1.109375 7.925781 1.605469 7.386719 2.222656 C 6.792969 2.878906 6.445312 3.691406 6.519531 4.609375 C 7.402344 4.675781 8.210938 4.230469 8.875 3.46875 Z M 8.875 3.46875 "
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgApple);
export default __webpack_public_path__ + "static/media/apple.ba904711.svg";
export { ForwardRef as ReactComponent };